exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".list-check{line-height:21px;margin:20px;font-size:13px}.list-check .list-check-ipsum{list-style-type:none}.fa-check{color:#61b8b0;padding-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-85807bde","scoped":false,"hasInlineConfig":true}!./src/components/list-check/list-check.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-85807bde","scoped":false,"hasInlineConfig":true}!./src/components/list-check/list-check.css
// module chunks = index